<template>
  <div class="ustn common-bg padding-nav">
    <page-menu/>
    <div>
      <router-view/>
    </div>
  </div>
</template>

<script>
import pageMenu from "./pageMenu/index.vue";
export default {
  components: {
    pageMenu,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {

  }
};
</script>
<style scoped lang="scss">

.ustn {

  .common-line {
    height: 1px;
    width: 70%;
    margin: 1.73rem auto 1.38rem auto;
    background: linear-gradient(91deg, #efefef, #cccccc, #efefef);
  }
}
</style>
